// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewWorkspace.test.tsx
import { Button, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

type AskV2ReviewChangedOnlyFilterProps = {
  onShowAll: () => void;
};

/** Says the list holds only the changed comments, with the way back to all of them. */
export function AskV2ReviewChangedOnlyFilter({
  onShowAll,
}: AskV2ReviewChangedOnlyFilterProps) {
  const { t } = useTranslation("ui");
  return (
    <div
      className="flex shrink-0 items-center justify-between gap-2 border-b border-puntt-neutral-gray-5 px-4 py-2"
      data-testid="ask-v2-review-changed-only-filter"
    >
      <Text size="2" weight="medium">
        {t("askV2.review.drawer.changedOnly.label")}
      </Text>
      <Button
        variant="ghost"
        color="gray"
        size="1"
        data-testid="ask-v2-review-changed-only-show-all"
        onClick={onShowAll}
      >
        {t("askV2.review.drawer.changedOnly.showAll")}
      </Button>
    </div>
  );
}
